<template>
  <div class="project-list-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <router-link to="/projectservices">服务项目</router-link> &gt;
        <span>项目服务列表</span>
      </div>
    </div>

    <main class="main-content container-fixed">
      <div class="section-header">
        <div class="en-title">PROJECT LIST</div>
        <div class="cn-title">项目服务列表</div>
      </div>

      <div class="project-grid">
        <div
          v-for="(item, index) in productList"
          :key="index"
          @click="getnoticeDetail(item.id)"
          class="project-card card-modern"
        >
          <div class="card-image">
            <img :src="item.imagesUrl" alt="" />
          </div>
          <div class="card-content">
            <div class="card-body">
              <h3 class="project-name">{{ item.name }}</h3>
              <p class="project-notes">{{ item.notes }}</p>
            </div>
            <div class="card-footer">
              <span class="view-detail"
                >了解更多 <i class="el-icon-right"></i
              ></span>
            </div>
          </div>
        </div>
      </div>

      <!-- 无数据状态 -->
      <div v-if="productList.length === 0" class="empty-state">
        <i class="el-icon-document-delete"></i>
        <p>暂无相关项目列表</p>
      </div>
    </main>
  </div>
</template>

<script>
import Banner from "../components/banner.vue";
import article from "@/api/article";

export default {
  name: "ProjectList",
  components: {
    Banner,
  },
  data() {
    return {
      Img1: require("../assets/images/banner1.png"),
      productList: [],
    };
  },
  created() {
    if (this.$route.query) {
      let serviceType = this.$route.query.serviceType;
      this.handleGetData(serviceType);
    }
  },
  methods: {
    handleGetData(serviceType) {
      article
        .productList({ serviceType: serviceType })
        .then((res) => {
          this.productList = res.data.data.records;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getnoticeDetail(id) {
      this.$router.push({
        path: "/projectdetail",
        query: { id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables.less";

.project-list-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  padding-bottom: 80px;
}

.project-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 40px;
}

.project-card {
  display: flex;
  background: #ffffff;
  height: 240px;
  overflow: hidden;
  cursor: pointer;

  .card-image {
    width: 360px;
    flex-shrink: 0;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }
  }

  .card-content {
    flex: 1;
    padding: 32px 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .project-name {
      font-size: 22px;
      font-weight: 700;
      color: @text-main;
      margin-bottom: 16px;
      transition: color 0.3s;
    }

    .project-notes {
      font-size: 14px;
      line-height: 1.6;
      color: @text-secondary;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .card-footer {
      display: flex;
      justify-content: flex-end;
      padding-top: 16px;
      border-top: 1px solid #f1f5f9;
    }

    .view-detail {
      font-size: 14px;
      font-weight: 600;
      color: @primary-color;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s;
      i {
        transition: transform 0.3s;
      }
    }
  }

  &:hover {
    .card-image img {
      transform: scale(1.05);
    }
    .card-content {
      .project-name {
        color: @primary-color;
      }
      .view-detail {
        gap: 16px;
        i {
          transform: translateX(6px);
        }
      }
    }
  }
}

.empty-state {
  padding: 100px 0;
  text-align: center;
  color: @text-muted;
  i {
    font-size: 64px;
    margin-bottom: 20px;
  }
  p {
    font-size: 18px;
  }
}

@media (max-width: 992px) {
  .project-card {
    height: auto;
    flex-direction: column;
    .card-image {
      width: 100%;
      height: 200px;
    }
    .card-content {
      padding: 24px;
    }
  }
}
</style>
